import { api } from '@/api/core';
import { MATTER_ABOUT_TAG } from '@/api/constants';

/**
 * Deletes one user-uploaded file from a case, along with its history row. Proclaim-synced
 * files cannot be deleted this way.
 */
export interface MatterDocumentDeleteRequest {
  matterId: string;
  fletchDocumentId: string;
}

export type MatterDocumentDeleteResponse = Record<string, never>;

const matterDocumentDeleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postMatterDocumentDelete: builder.mutation<MatterDocumentDeleteResponse, MatterDocumentDeleteRequest>({
      query: (body) => ({
        url: '/matter/document/delete',
        method: 'POST',
        body,
      }),
      // `matter/about` carries the processing flag, which a deleted in-flight upload no longer counts towards.
      invalidatesTags: (_result, _error, { matterId }) => [{ type: MATTER_ABOUT_TAG, id: matterId }],
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostMatterDocumentDeleteMutation } = matterDocumentDeleteApi;
